import useSWR from "swr";

import { type FetcherError, fetcher } from "../fetcher";
import { type TierDetails } from "~/api/types";

interface TierWithDocuments extends TierDetails {
  details: {
    documents: number;
  };
}

export function useTierDetails(id?: number, revalidateOnMount = false) {
  const { data, error, mutate } = useSWR<TierWithDocuments, FetcherError>(
    id ? `/tier/${id}/details` : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnMount,
    },
  );
  return { data, error, mutate, isLoading: !data && !error };
}
